/* eslint-disable react/jsx-curly-newline */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-else-return */
import React, { useEffect, useState } from "react";
import { Form, Col, Row, Button, Image, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Typeahead } from "react-bootstrap-typeahead";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import hotImg from "../assets/imgs/hot.png";
import sunnyImg from "../assets/imgs/sunny.png";
import partlyCloudyImg from "../assets/imgs/partly_cloudy.png";
import cloudyImg from "../assets/imgs/cloudy.png";
import rainImg from "../assets/imgs/rain.png";

import "../styles/DailyActivity.css";
import axiosInstance from "../axiosInstance";
import { useParams } from "react-router-dom";

export default function DailyActivity() {
  const { reference, id } = useParams();
  const [startDate, setStartDate] = useState(new Date());
  const [wake_up_time, setWakeUpTime] = useState(new Date());
  const [walking_end_time, setEndTime] = useState(new Date());
  const [walking_start_time, setStartTime] = useState(new Date());
  const [reference_number, setReferenceNumber] = useState([]);
  const [area_walked, setAreaWalked] = useState("");
  const [final_weight, setFinalWeight] = useState(0);
  const [initial_weight, setInitialWeight] = useState(0);
  const [walker, setWalker] = useState("");
  const [defacation, setDefacation] = useState("No");
  const [drank_water, setDrankWater] = useState("No");
  const [manure_weight, setManureWeight] = useState(0);
  const [total_time_walked, setTotalTimeWalked] = useState(0);
  const [comments, setComments] = useState("");
  const [weather, setWeather] = useState("Sunny and Hot");
  const [options, setOptions] = useState([]);

  const [showSave, setShowSave] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleCloseSave = () => setShowSave(false);
  const handleCloseSuccess = () => setShowSuccess(false);
  const handleSave = () => {
    submit();
    setShowSave(false);
  };
  function handleShowSave(e) {
    e.preventDefault();
    setShowSave(true);
  }

  async function submit() {
    const ref = reference_number[0];
    let result;
    if (reference) {
      result = await axiosInstance.post("/api/update-daily-activity", {
        date: startDate,
        reference_number: reference,
        area_walked,
        final_weight,
        initial_weight,
        walker,
        defacation,
        drank_water,
        manure_weight,
        wake_up_time,
        walking_start_time,
        walking_end_time,
        total_time_walked,
        comments,
        weather,
        id,
      });
    } else {
      result = await axiosInstance.post("/api/add-daily-activity", {
        date: startDate,
        reference_number: ref,
        area_walked,
        final_weight,
        initial_weight,
        walker,
        defacation,
        drank_water,
        manure_weight,
        wake_up_time,
        walking_start_time,
        walking_end_time,
        total_time_walked,
        comments,
        weather,
      });
    }
    if (result.data.code !== "ER_PARSE_ERROR") {
      toast.success(result.data, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
      if (!reference) {
        setInitialWeight(0);
        setFinalWeight(0);
        setStartDate(new Date());
        setWakeUpTime(new Date());
        setReferenceNumber([]);
        setWalker("");
        setAreaWalked("");
        setTotalTimeWalked(0);
        setEndTime(new Date());
        setStartTime(new Date());
        setWeather("Sunny and Hot");
        setComments("");
        setDrankWater("No");
        setDefacation("No");
        setManureWeight(0);
      }
    } else {
      toast.error(result.data.sqlMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    }
  }

  async function getReferences() {
    const result = await axiosInstance.get("/api/all-reference-numbers");
    const numbers = result.data;
    const refs = [];
    numbers.forEach((element) => {
      refs.push(element.reference_number);
    });
    setOptions(refs);
  }

  async function populateData() {
    const result = await axiosInstance.post("/api/get-daily-activity-ref-id", {
      id,
      reference_number: reference,
    });
    const data = result.data[0];
    console.log(result);
    let endTime = new Date(data.walking_end_time);
    let startTime = new Date(data.walking_start_time);

    // Calculate the difference in time (in milliseconds).
    let differenceInMilliseconds = endTime - startTime;

    // Convert milliseconds to hours.
    let differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);

    setTotalTimeWalked(differenceInHours);

    setStartDate(new Date(data.date));
    setAreaWalked(data.area_walked);
    setInitialWeight(data.initial_weight);
    setFinalWeight(data.final_weight);
    setReferenceNumber([data.reference_number]);
    setWalker(data.walker);
    setDefacation(data.defacation);
    setDrankWater(data.drank_water);
    setManureWeight(data.manure_weight);
    setWakeUpTime(new Date(data.wake_up_time));
    setEndTime(endTime);
    setStartTime(startTime);
    setTotalTimeWalked(differenceInHours);
    setComments(data.comments);
    setWeather(data.weather);
  }

  useEffect(() => {
    getReferences();
    if (reference) {
      populateData();
    }
  }, [reference]);

  return (
    <div className="daily">
      <div className="formGroup">
        <h2 className="heading">Daily Activity Sheet</h2>
        <Form.Group as={Col} controlId="formGroupDate">
          <DatePicker
            className="datepicker"
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            showTimeSelect
            timeIntervals={1}
            dateFormat="dd/MM/yyyy HH:mm"
          />
        </Form.Group>
        <Form>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupReference">
                <Form.Label>Reference Number</Form.Label>
                <Typeahead
                  id="reference-number"
                  labelKey="name"
                  onChange={setReferenceNumber}
                  options={options}
                  placeholder="Choose a reference number..."
                  selected={reference_number}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupWalked">
                <Form.Label>Area Walked</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Area Walked"
                  value={area_walked}
                  onChange={(e) => setAreaWalked(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupInitWeight">
                <Form.Label>Initial Weight</Form.Label>
                <Row>
                  <Col xs={10}>
                    <Form.Control
                      type="text"
                      placeholder="Initial Weight"
                      value={initial_weight}
                      onChange={(e) => {
                        const regex = new RegExp(
                          "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                        );
                        if (regex.test(e.target.value)) {
                          const s = e.target.value.replace(
                            /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                            ""
                          );
                          setInitialWeight(s);
                        } else if (e.target.value === "") {
                          setInitialWeight(0);
                        }
                      }}
                    />
                  </Col>
                  <Col className="labelcol">
                    <Form.Label className="label">kgs</Form.Label>
                  </Col>
                </Row>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupFinalWeight">
                <Form.Label>Final Weight</Form.Label>
                <Row>
                  <Col xs={10}>
                    <Form.Control
                      type="text"
                      placeholder="Final Weight"
                      value={final_weight}
                      onChange={(e) => {
                        const regex = new RegExp(
                          "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                        );
                        if (regex.test(e.target.value)) {
                          const s = e.target.value.replace(
                            /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                            ""
                          );
                          setFinalWeight(s);
                        } else if (e.target.value === "") {
                          setFinalWeight(0);
                        }
                      }}
                    />
                  </Col>
                  <Col className="labelcol">
                    <Form.Label className="label">kgs</Form.Label>
                  </Col>
                </Row>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupWaler">
                <Form.Label>Walker</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Walker"
                  value={walker}
                  onChange={(e) => setWalker(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupDefacation">
                <Form.Label>Defecation</Form.Label>
                <Form.Check
                  type="radio"
                  id="defacation-radio-yes"
                  label="Yes"
                  name="defacationRadios"
                  value="Yes"
                  onChange={(e) => setDefacation(e.target.value)}
                  checked={defacation === "Yes"}
                />
                <Form.Check
                  type="radio"
                  id="defacation-radio-no"
                  label="No"
                  name="defacationRadios"
                  value="No"
                  onChange={(e) => setDefacation(e.target.value)}
                  checked={defacation === "No"}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group as={Col} controlId="formGroupWater">
                <Form.Label>Drank Water</Form.Label>
                <Form.Check
                  type="radio"
                  id="water-radio-yes"
                  label="Yes"
                  name="waterRadios"
                  value="Yes"
                  onChange={(e) => setDrankWater(e.target.value)}
                  checked={drank_water === "Yes"}
                />
                <Form.Check
                  type="radio"
                  id="water-radio-no"
                  label="No"
                  name="waterRadios"
                  value="Yes"
                  onChange={(e) => setDrankWater(e.target.value)}
                  checked={drank_water === "No"}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupTime">
                <Form.Label>Manure Weight</Form.Label>
                <Row>
                  <Col xs={10}>
                    <Form.Control
                      type="text"
                      placeholder="Manure Weight"
                      value={manure_weight}
                      onChange={(e) => {
                        const regex = new RegExp(
                          "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                        );
                        if (regex.test(e.target.value)) {
                          const s = e.target.value.replace(
                            /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                            ""
                          );
                          setManureWeight(s);
                        } else if (e.target.value === "") {
                          setManureWeight(0);
                        }
                      }}
                    />
                  </Col>
                  <Col className="labelcol">
                    <Form.Label className="label">grams</Form.Label>
                  </Col>
                </Row>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupWake">
                <Form.Label>Wake Up Time</Form.Label>
                <br />
                <DatePicker
                  className="datepicker"
                  selected={wake_up_time}
                  onChange={(date) => setWakeUpTime(date)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={1}
                  dateFormat="HH:mm"
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupStart">
                <Form.Label>Walking Start Time</Form.Label>
                <br />
                <DatePicker
                  className="datepicker"
                  selected={walking_start_time}
                  onChange={(date) => setStartTime(date)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={1}
                  dateFormat="HH:mm"
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupEnd">
                <Form.Label>Walking Time Finish</Form.Label>
                <br />
                <DatePicker
                  className="datepicker"
                  selected={walking_end_time}
                  onChange={(date) => setEndTime(date)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={1}
                  dateFormat="HH:mm"
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupArea">
                <Form.Label>Total Time Walked</Form.Label>
                <Row>
                  <Col xs={10}>
                    <Form.Control
                      type="text"
                      value={
                        Math.round(
                          (walking_end_time.getHours() -
                            walking_start_time.getHours() +
                            (walking_end_time.getMinutes() -
                              walking_start_time.getMinutes()) /
                              60) *
                            1000
                        ) / 1000
                      }
                      onChange={(e) => {
                        if (parseFloat(e.target.value)) {
                          setTotalTimeWalked(parseFloat(e.target.value));
                        } else {
                          setTotalTimeWalked(0);
                        }
                      }}
                      disabled
                    />
                  </Col>
                  <Col className="labelcol">
                    <Form.Label className="label">hours</Form.Label>
                  </Col>
                </Row>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Label>Comments or Observations</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Comments or Observations"
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="text-center">
            <Form.Group as={Col} controlId="formGroupWeather">
              <Image src={hotImg} alt="Sunny and Hot" />
              <br />
              <Form.Label>Sunny and Hot</Form.Label>
              <Form.Check
                type="radio"
                id="sunny_and_hot"
                name="weatherRadios"
                value="Sunny and Hot"
                onChange={(e) => setWeather(e.target.value)}
                checked={weather === "Sunny and Hot"}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGroupWeather">
              <Image src={sunnyImg} />
              <br />
              <Form.Label>Sunny</Form.Label>
              <Form.Check
                type="radio"
                id="sunny"
                name="weatherRadios"
                value="Sunny"
                onChange={(e) => setWeather(e.target.value)}
                checked={weather === "Sunny"}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGroupWeather">
              <Image src={partlyCloudyImg} />
              <br />
              <Form.Label>Partly Cloudy</Form.Label>
              <Form.Check
                type="radio"
                id="partly_cloudy"
                name="weatherRadios"
                value="Partly Cloudy"
                onChange={(e) => setWeather(e.target.value)}
                checked={weather === "Partly Cloudy"}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGroupWeather">
              <Image src={cloudyImg} />
              <br />
              <Form.Label>Overcast</Form.Label>
              <Form.Check
                type="radio"
                id="clouds"
                name="weatherRadios"
                value="Overcast"
                onChange={(e) => setWeather(e.target.value)}
                checked={weather === "Overcast"}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGroupWeather">
              <Image src={rainImg} />
              <br />
              <Form.Label>Rain</Form.Label>
              <Form.Check
                type="radio"
                id="rain"
                name="weatherRadios"
                value="Rain"
                onChange={(e) => setWeather(e.target.value)}
                checked={weather === "Rain"}
              />
            </Form.Group>
          </Row>
          <Row>
            <Col>
              <Button
                className="submit-button"
                type="submit"
                onClick={(e) => {
                  handleShowSave(e);
                }}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
      <div>
        <Modal show={showSave} onHide={handleCloseSave}>
          <Modal.Header closeButton>
            <Modal.Title>Save</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>Are you sure you want to save this device.</p>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSave}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div>
        <Modal show={showSuccess} onHide={handleCloseSuccess}>
          <Modal.Header closeButton>
            <Modal.Title>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Successfuly Submited.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSuccess}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}
